import { createRouter, createWebHistory } from 'vue-router'

import { app, pages } from '@/config'

const Home = () => import('@/pages/Home.vue')
const ApplicationForm = () => import('@/pages/ApplicationForm.vue')
const JobDetail = () => import('@/pages/JobDetail.vue')
const SearchResult = () => import('@/pages/SearchResult.vue')
const JobTrackingResult = () => import('@/pages/JobTrackingResult.vue')
const MotivationalFit = () => import('@/pages/MotivationalFit.vue')
const MotivationalFitResult = () => import('@/pages/MotivationalFitResult.vue')
const ReferralPage = () => import('@/pages/ReferralPage.vue')
const Detail = () => import('@/pages/Detail.vue')
const PrivacyNotice = () => import('@/pages/PrivacyNotice.vue')
const LifeAtBlibli = () => import('@/pages/LifeAtBlibli.vue')

const routes = [
  {
    path: pages.home,
    name: app.routerName.home,
    component: Home
  },
  {
    path: pages.generalForm,
    component: ApplicationForm,
    name: app.routerName.generalForm
  },
  {
    path: pages.jobDetail + '/:title',
    component: JobDetail,
    name: app.routerName.jobDetail
  },
  {
    path: pages.jobsResult,
    component: SearchResult,
    name: app.routerName.jobsResult
  },
  {
    path: pages.jobTrackingResult,
    component: JobTrackingResult,
    name: app.routerName.jobTrackingResult
  },
  {
    path: pages.futureProgram,
    beforeEnter () { location.href = 'https://www.blibli.com/page/future-program/' },
    name: app.routerName.futureProgram
  },
  {
    path: pages.motivationalFit,
    component: MotivationalFit,
    name: app.routerName.motivationalFit
  },
  {
    path: pages.motivationalFitResult,
    component: MotivationalFitResult,
    name: app.routerName.motivationalFitResult
  },
  {
    path: pages.referralPage,
    component: ReferralPage,
    name: app.routerName.referralPage
  },
  {
    path: pages.privacyNotice,
    name: app.routerName.privacyNotice,
    component: PrivacyNotice
  },
  {
    path: pages.details,
    name: app.routerName.details,
    component: Detail
  },
  {
    path: pages.lifeAtBlibli,
    name: app.routerName.lifeAtBlibli,
    component: LifeAtBlibli
  }
]

const router = createRouter({
  scrollBehavior (to, from, savedPosition) {
    // always scroll to top
    return { top: 0, behavior: 'smooth' }
  },
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  if (to.name == app.routerName.applicationForm) {
    return {
      name: app.routerName.generalForm,
      query: { companyId: 'GDN' }
    }
  }

  return true
})

export default router
